export const flags = {"AT":"at.svg","BE":"be.svg","CA":"ca.svg","DE":"de.svg","DK":"dk.svg","EE":"ee.svg","ES":"es.svg","EU":"eu.svg","FI":"fi.svg","FR":"fr.svg","GB":"gb.svg","NO":"no.svg","SE":"se.svg","US":"us.svg"};
export default {
  "flags": {
    "AT": "at.svg",
    "BE": "be.svg",
    "CA": "ca.svg",
    "DE": "de.svg",
    "DK": "dk.svg",
    "EE": "ee.svg",
    "ES": "es.svg",
    "EU": "eu.svg",
    "FI": "fi.svg",
    "FR": "fr.svg",
    "GB": "gb.svg",
    "NO": "no.svg",
    "SE": "se.svg",
    "US": "us.svg"
  }
}
;